import React from "react";
import cx from "classnames";
import styles from "./index.module.scss";

interface ITextProps<DomElementType>
  extends React.HTMLAttributes<DomElementType>,
    React.SVGAttributes<DomElementType> {
  component?: React.ElementType;
  size?: "tiny" | "small" | "medium" | "large" | "xlarge";
  weight?: "light" | "regular" | "bold";
  fade?: boolean;
  lineHeight?: "small" | "medium" | "large" | "xlarge";
}

export function Text<DomElementType = "p" | "span">({
  component = "p",
  size = "medium",
  weight = "regular",
  fade = false,
  lineHeight,
  className,
  ...props
}: ITextProps<DomElementType>) {
  const Component = component;
  return (
    <Component
      {...props}
      className={cx(
        className,
        styles.text,
        styles[size],
        styles[weight],
        fade && styles.fade,
        lineHeight && styles[`line-height-${lineHeight}`]
      )}
    />
  );
}

type HeadingSizes = "h1" | "h2" | "h3" | "h4" | "h5";
interface IHeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
  component?: React.ElementType;
  size: HeadingSizes;
}

export const Heading = ({
  component,
  size,
  className,
  ...props
}: IHeadingProps) => {
  let Component = component;
  if (!Component) {
    Component = size;
  }
  return (
    <Component
      {...props}
      className={cx(className, styles.heading, styles[size])}
    />
  );
};

interface IDisplayProps<DomElementType>
  extends React.HTMLAttributes<DomElementType> {
  component?: React.ElementType;
  size?: "small" | "large";
}

export function DisplayText<DomElementType>({
  component = "p",
  size = "small",
  className,
  ...props
}: IDisplayProps<DomElementType>) {
  const Component = component;
  return (
    <Component
      {...props}
      className={cx(className, styles.display, styles[size])}
    />
  );
}
